module.exports = __webpack_public_path__ + "img/a_pro.23fb3662.png";